<template>
  <div class="counter inline">
    <div class="fa-minus">
      <font-awesome-icon
        :icon="minus"
        @click="decrement"
        :class="{'is-active': activeD}"
      />
    </div>
    <span class="count">{{count}}</span>
    <div class="fa-plus">
      <font-awesome-icon
        :icon="plus"
        @click="increment"
        :class="{'is-active': canAddMore}"
      />
    </div>
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import { faMinus, faPlus } from '@fortawesome/fontawesome-free-solid';

export default {
  name: 'Counter',
  props: {
    initCount: {
      type: Number,
      default() {
        return 0;
      },
    },
    min: {
      type: Number,
      default() {
        return 0;
      },
    },
    age: {
      type: String,
      required: true,
    },
    canAddMore: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  data() {
    return {
      count: this.initCount,
    };
  },
  computed: {
    minus() {
      return faMinus;
    },
    plus() {
      return faPlus;
    },
    activeD() {
      if (this.min === this.count) {
        return false;
      }

      return true;
    },
  },
  methods: {
    increment() {
      if (this.canAddMore) {
        this.count += 1;
        this.$emit('counterChange', this.count, this.age);
      }
    },
    decrement() {
      if (this.count > this.min) {
        this.count -= 1;
        this.$emit('counterChange', this.count, this.age);
      }
    },
  },
  components: {
    FontAwesomeIcon,
  },
};
</script>

<style scoped lang="scss">
#app, #auth {
  .counter {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    float: right;

    .count {
      padding-left: 7px;
      padding-right: 7px;
    }

    .fa-minus,
    .fa-plus {
      display: inline-block;

      svg {
        font-size: 16px;
        cursor: pointer;
      }
    }

    &.inline {
      display: inline-block;
    }

    .is-active{
      color: $color-main;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Counter/Counter.vue